export interface IAutomatable {
    /**
     * This attribute is reserved for QA Engineers and can not be modified
     */
    dataAutomationClass?: never;
}

/**
 * This function prevents the props from ever providing a data automation class in any manner (i.e. camel-case and/or snake case)
 */
export function preventDataAutomationOverriding<T extends IAutomatable>(
    props: T
): Omit<T, 'dataAutomationClass'> {
    if (props.dataAutomationClass) {
        throw new Error('dataAutomationClass can not be set externally.');
    }
    if ('data-automation-class' in props) {
        throw new Error('data-automation-class can not be set externally.');
    }
    return props;
}
